import { HeadCell } from 'components/public/Listado/Listado';
import { ISelectOptions, ListadoCompra, TextoSala } from './models/interfaces';
import {
  AlquilerBase,
  Boletin,
  CompraBase,
  DiasSemana,
  EspectaculoBase,
  TallerBase,
  TallerListadoAlumno,
  UsuarioAlumno,
  UsuarioBase,
} from './models/types';
import Sala1 from 'assets/fotosSalas/Sala1-1.jpeg';
import Sala2 from 'assets/fotosSalas/Sala2.jpeg';
import ComingSoon from 'assets/fotosSalas/ComingSoon.jpg';
import { crearOpcionesSelect } from './utilities';
import { hasErrorCompra } from './storage/compra';

export { datosTeatro } from '../content/site';
export * from '../ui/menus';

// OPCIONES PARA SELECTS:
export const opcionesDias: ISelectOptions[] = crearOpcionesSelect(DiasSemana, 'Dias');

export const placeholderAlquiler =
  'Hola Teatro Bosch, estoy interesado/a en alquilar la sala seleccionada, por favor comuníquense conmigo. ¡Gracias!';

// DASTOS LISTADOS
export const titulosListadoUsuario: HeadCell<UsuarioBase>[] = [
  { Id: 'Nombre', numeric: false, disablePadding: true, label: 'Nombre completo' },
  { Id: 'Email', numeric: false, disablePadding: true, label: 'Correo' },
  { Id: 'Rol', numeric: false, disablePadding: true, label: 'Rol' },
  { Id: 'DescuentoAsignado', numeric: true, disablePadding: true, label: 'Descuento' },
  { Id: 'TipoSocio', numeric: false, disablePadding: true, label: 'Tipo Socio' },
  { Id: 'EsElenco', numeric: false, disablePadding: true, label: 'Elenco' },
  { Id: 'EsAlumno', numeric: false, disablePadding: true, label: 'Alumno' },
  { Id: 'Activo', numeric: false, disablePadding: true, label: 'Activo' },
];

export const titulosListadoAlumnosPorTaller: HeadCell<UsuarioAlumno>[] = [
  { Id: 'Nombre', numeric: false, disablePadding: true, label: 'Nombre completo' },
  { Id: 'Email', numeric: false, disablePadding: true, label: 'Correo' },
  { Id: 'Rol', numeric: false, disablePadding: true, label: 'Rol' },
  { Id: 'DescuentoAsignado', numeric: true, disablePadding: true, label: 'Descuento' },
  { Id: 'TipoSocio', numeric: false, disablePadding: true, label: 'Tipo Socio' },
  { Id: 'EsElenco', numeric: false, disablePadding: true, label: 'Elenco' },
  { Id: 'Activo', numeric: false, disablePadding: true, label: 'Activo' },
];

export const titulosListadoCompras: HeadCell<ListadoCompra>[] = [
  { Id: 'NombreUsuario', numeric: false, disablePadding: true, label: 'Nombre usuario' },
  { Id: 'NombreEspectaculo', numeric: false, disablePadding: true, label: 'Espectáculo' },
  { Id: 'CantAsientos', numeric: true, disablePadding: true, label: 'Cantidad' },
  { Id: 'Aprobada', numeric: true, disablePadding: true, label: 'Aprobada' },
  { Id: 'Codigo', numeric: true, disablePadding: true, label: 'Código' },
  { Id: 'DescuentoAplicado', numeric: true, disablePadding: true, label: 'Descuento' },
  { Id: 'FechaCompra', numeric: true, disablePadding: true, label: 'Fecha compra' },
  { Id: 'FechaInicioFuncion', numeric: true, disablePadding: true, label: 'Función' },
  { Id: 'MontoSinDescuento', numeric: true, disablePadding: true, label: 'Monto' },
];

export const titulosListadoComprasUsuario: HeadCell<CompraBase>[] = [
  { Id: 'FechaInicioFuncion', numeric: false, disablePadding: true, label: 'Fecha' },
  { Id: 'NombreEspectaculo', numeric: false, disablePadding: true, label: 'Espectáculo' },
  { Id: 'CantAsientos', numeric: true, disablePadding: true, label: 'Cantidad' },
  { Id: 'Codigo', numeric: true, disablePadding: true, label: 'Código' },
  { Id: 'Precio', numeric: true, disablePadding: true, label: 'Total pagado' },
  { Id: 'DescuentoAplicado', numeric: true, disablePadding: true, label: 'Descuento' },
  { Id: 'FechaCompra', numeric: false, disablePadding: true, label: 'Fecha compra' },
  { Id: 'Aprobada', numeric: false, disablePadding: true, label: 'Aprobada' },
];

export const titulosListadoVentas: HeadCell<any>[] = [
  { Id: 'NombreEspectaculo', numeric: false, disablePadding: true, label: 'Espectáculo' },
  { Id: 'FechaInicioTemporada', numeric: false, disablePadding: true, label: 'Inicio temporada' },
  { Id: 'FechaFinTemporada', numeric: false, disablePadding: true, label: 'Fin temporada' },
  { Id: 'CantEntradasVendidas', numeric: true, disablePadding: true, label: 'Entradas vendidas' },
  { Id: 'MontoTotalVentaEntradas', numeric: true, disablePadding: true, label: 'Monto por entradas' },
  { Id: 'MontoTotalGananciaEntradas', numeric: true, disablePadding: true, label: 'Ganancia de entradas' },
];

export const titulosListadoTalleresDeUsuario: HeadCell<TallerListadoAlumno>[] = [
  { Id: 'Nombre', numeric: false, disablePadding: true, label: 'Nombre' },
  { Id: 'NombreSala', numeric: false, disablePadding: true, label: 'Sala' },
  { Id: 'Docente', numeric: false, disablePadding: true, label: 'Docente' },
  { Id: 'FechaInicio', numeric: false, disablePadding: true, label: 'Inicio' },
  { Id: 'FechaFin', numeric: false, disablePadding: true, label: 'Fin' },
  { Id: 'Dias', numeric: true, disablePadding: true, label: 'Horarios' },
  { Id: 'ValorCuota', numeric: false, disablePadding: true, label: 'Cuota' },
  { Id: 'AficheUrl', numeric: false, disablePadding: true, label: 'Afiche' },
];

export const titulosListadoTalleres: HeadCell<TallerBase>[] = [
  { Id: 'Nombre', numeric: false, disablePadding: true, label: 'Nombre' },
  { Id: 'NombreSala', numeric: false, disablePadding: true, label: 'Sala' },
  { Id: 'Docente', numeric: false, disablePadding: true, label: 'Docente' },
  { Id: 'FechaInicio', numeric: false, disablePadding: true, label: 'Inicio' },
  { Id: 'FechaFin', numeric: false, disablePadding: true, label: 'Fin' },
  { Id: 'Dias', numeric: true, disablePadding: true, label: 'Horarios' },
  { Id: 'ValorCuota', numeric: true, disablePadding: true, label: 'Cuota' },
  { Id: 'AficheUrl', numeric: false, disablePadding: true, label: 'Afiche' },
  { Id: 'Programa', numeric: false, disablePadding: true, label: 'Inscriptos' },
  { Id: 'VisibleEnGrilla', numeric: false, disablePadding: true, label: 'Visible' },
];

export const titulosListadoAlquileres: HeadCell<AlquilerBase>[] = [
  { Id: 'NombreInquilino', numeric: false, disablePadding: true, label: 'Nombre Inquilino' },
  { Id: 'Telefono', numeric: true, disablePadding: true, label: 'Teléfono' },
  { Id: 'NombreSala', numeric: false, disablePadding: true, label: 'Sala' },
  { Id: 'FechaInicio', numeric: false, disablePadding: true, label: 'Fecha inicio' },
  { Id: 'FechaFin', numeric: false, disablePadding: true, label: 'Fecha fin' },
  { Id: 'Monto', numeric: true, disablePadding: true, label: 'Monto' },
];

export const titulosListadoEspectaculos: HeadCell<EspectaculoBase>[] = [
  { Id: 'Nombre', numeric: false, disablePadding: true, label: 'Nombre' },
  { Id: 'AficheUrl', numeric: false, disablePadding: true, label: 'Afiche' },
  { Id: 'BannerUrl', numeric: false, disablePadding: true, label: 'Banner' },
  { Id: 'Temporada', numeric: false, disablePadding: true, label: 'Temporada' },
  { Id: 'Precio', numeric: true, disablePadding: true, label: 'Precio' },
  { Id: 'BannerDestacado', numeric: false, disablePadding: true, label: 'Banner visible' },
  { Id: 'VisibleEnGrilla', numeric: false, disablePadding: true, label: 'Visible' },
];

export const titulosListadoBoletines: HeadCell<Boletin>[] = [
  { Id: 'NombreEnviador', numeric: false, disablePadding: true, label: 'Enviado Por' },
  { Id: 'Asunto', numeric: false, disablePadding: true, label: 'Asunto' },
  { Id: 'Titulo', numeric: false, disablePadding: true, label: 'Título' },
  { Id: 'Body', numeric: false, disablePadding: true, label: 'Cuerpo' },
  { Id: 'ImagenUrl', numeric: false, disablePadding: true, label: 'Imagen' },
  { Id: 'FechaEnviado', numeric: false, disablePadding: true, label: 'Fecha' },
];

export const pasosCompraBase = [
  'Elegir asiento/s',
  'Confirmar compra',
  'Efectuar pago',
];

export const getPasosCompra = () => {
  return [...pasosCompraBase, `${hasErrorCompra() ? 'Error' : 'Listo'}`];
};
export const SALA_TEATRO = 'Sala Teatro Bosch';
export const googleMapsTeatro =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.774285975395!2d-56.17782602303314!3d-34.91211347385285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f81ba26ae9f5d%3A0xd194eed8044ed2ec!2sCentro%20Cultural%20H.%20Bosch!5e0!3m2!1ses!2suy!4v1723410330812!5m2!1ses!2suy';

export * from '../content/legal';
export * from '../routing/routes';
export * from '../ui/layout';

export const textoSalas: TextoSala[] = [
  {
    nombre: 'Sala 1',
    descripcion1: 'Con balcón a la calle - Dimensiones 5,10 x 4,00 mts.',
    descripcion2: 'Tiene una pared con espejo de 4,00 x 2,20mt.',
    foto: Sala1,
  },
  {
    nombre: 'Sala 2',
    descripcion1: 'Interior - Dimensiones: 3,10 x 3,50 mts.',
    foto: Sala2,
  },
  {
    nombre: 'Sala 3',
    descripcion1: 'Interior - Dimensiones: 5,60 x 3,30 mts.',
    descripcion2: 'Tiene una pared con espejo de 5,00 x 2,20 mts.',
    foto: ComingSoon,
  },
];
